import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  getAllInformationReqTemplates,
  InformationCategoryDTO,
  mapJobWithInformationReqTemplate,
} from 'wisestep-api';
import { WsRadioGroup, WsRadioObj } from 'wisestep-base';

import { success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

export const InformationCategoryMappingDialog = ({ handleCloseDialog, jobId, mappedTemplates }) => {
  const form = useForm();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [informationCategories, setInformationCategories] = useState<InformationCategoryDTO[]>();

  const fetchInformationCategories = async () => {
    const { data } = await getAllInformationReqTemplates();
    const filteredRtrData = data.filter(({ rtrTemplate }) => rtrTemplate === '');
    setInformationCategories(filteredRtrData);
  };

  useEffect(() => {
    fetchInformationCategories();
  }, []);

  const options: WsRadioObj[] =
    informationCategories
      ?.filter(
        ({ id }) =>
          !mappedTemplates
            ?.map(({ informationReqTemplateId }) => informationReqTemplateId)
            .includes(id)
      )
      ?.map(({ categoryName, id }) => ({
        value: id as string,
        label: categoryName as string,
      })) ?? [];

  return (
    <>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Add Information Request Template
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleCloseDialog}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(async (data) => {
            await mapJobWithInformationReqTemplate({
              jobId: jobId ?? '',
              informationReqTemplateId: data.informationReqTemplateId,
            });
            handleCloseDialog();
            setNotification(success('Information Request Template associated with job!'));
          })}
        >
          <DialogContent dividers>
            <Stack justifyContent="space-between" minHeight={256}>
              <WsRadioGroup
                label="Select the Information Request Template"
                name="informationReqTemplateId"
                selectArray={options}
                row={false}
                required
              />
              <Typography gutterBottom>
                *Selecting Information Request Template/s will associate them for all the candidates
                selected for the job.
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button variant="contained" type="submit" disabled={options.length === 0}>
              Add Template
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </>
  );
};
